import React, { useState, useEffect } from 'react';
import moment from "moment"

import { ContentBox } from '../ContentBox';
import { SingleSelect, SingleInput, getDangerText, getSuccessText, getInfoText } from '../../Res/BaseInput';
import { ReqContractorAttendance, ContractorAttendanceInfo_SalaryMonthly, ReqInsuranceCostItem, ReqInsuranceCostRate, ReqInsuranceAmount, ReqInsuranceRecruitmentItem, ContractorAttendanceInfo_SalaryHourly } from '../../../../item/ItemContractorAttendance';
import { DailogHtml } from '../../../DailogHtml';
import { CancelSubmitButton, CancelButton, SubmitButton } from '../../Res/BaseButton';
import { ContractorAttendanceDailogAttendanceDay } from './ContractorAttendanceDailogAttendanceDay';
import { InsuranceBurdenType_Company } from '../../../../item/ItemCustomerPosition';

export function ContractorInsuranceCostList({ type, insuranceCostItem, contractorAttendance, toSave, getContractor }) {
    const [mReqContractorAttendance, setContractorAttendance] = useState(new ReqContractorAttendance({}))
    const [InsuranceCostItem, setInsuranceCostItem] = useState([])
    const [InsuranceRecruitmentList, setInsuranceRecruitmentList] = useState([])
    const [InsuranceAmount, setInsuranceAmount] = useState({})
    const [InsuranceCostRate, setInsuranceCostRate] = useState({})

    const [dialogTitle, setDialogTitle] = useState(<></>)
    const [dialogContent, setDialogContent] = useState(<></>)
    const [dialogAction, setDialogAction] = useState(<></>)
    const [open, setOpen] = React.useState(false);


    const [AccidentRate, setAccidentRate] = useState(0)
    const [EmploymentRate, setEmploymentRate] = useState(0)
    const [OccupationalAccidentRate, setOccupationalAccidentRate] = useState(0)
    const [WageArrearsPaymentFundRate, setWageArrearsPaymentFundRate] = useState(0)
    const [LaborPensionRate, setLaborPensionRate] = useState(0)
    const [HealthRate, setHealthRate] = useState(0)
    const [FamilyAVG, setFamilyAVG] = useState(0)
    const [CustomerSupplementaryPremium, setCustomerSupplementaryPremium] = useState(0)
    const [FoundRate, setFoundRate] = useState(0)

    // const [MonthlySalaryAmount, setMonthlySalaryAmount] = useState(0)
    const [SalaryAmount, setSalaryAmount] = useState(0)

    const [CompanyAmount, setCompanyAmount] = useState("")
    const [CompanyLaborInsurance, setCompanyLaborInsurance] = useState("")
    const [CompanyLaborPension, setCompanyLaborPension] = useState("")
    const [CompanyHealthInsurance, setCompanyHealthInsurance] = useState("")
    const [CompanyGroupInsurance, setCompanyGroupInsurance] = useState("")
    const [CompanyPersonPremium, setCompanyPersonPremium] = useState("")
    const [CompanyAddInsuranceBurdenType, setCompanyAddInsuranceBurdenType] = useState("")
    const [CompanyServiceFee, setCompanyServiceFee] = useState("")

    const [CustomerAmount, setCustomerAmount] = useState("")
    const [CustomerLaborInsurance, setCustomerLaborInsurance] = useState("")
    const [CustomerLaborPension, setCustomerLaborPension] = useState("")
    const [CustomerHealthInsurance, setCustomerHealthInsurance] = useState("")
    const [CustomerGroupInsurance, setCustomerGroupInsurance] = useState("")
    const [CustomerPersonPremium, setCustomerPersonPremium] = useState("")
    const [CustomerAddInsuranceBurdenType, setCustomerAddInsuranceBurdenType] = useState("")
    const [CustomerServiceFee, setCustomerServiceFee] = useState("")

    const [PersonAmount, setPersonAmount] = useState("")
    const [PersonLaborInsurance, setPersonLaborInsurance] = useState("")
    const [PersonLaborPension, setPersonLaborPension] = useState("")
    const [PersonHealthInsurance, setPersonHealthInsurance] = useState("")
    const [PersonGroupInsurance, setPersonGroupInsurance] = useState("")
    const [PersonPersonPremium, setPersonPersonPremium] = useState("")
    const [PersonAddInsuranceBurdenType, setPersonAddInsuranceBurdenType] = useState("")
    const [PersonServiceFee, setPersonServiceFee] = useState("")

    const [FoundAmount, setFoundAmount] = useState("")
    const [FoundServiceFee, setFoundServiceFee] = useState("")

    const [init, setInit] = useState(true)

    useEffect(() => {
        if (contractorAttendance !== undefined && contractorAttendance !== mReqContractorAttendance) {
            setContractorAttendance(contractorAttendance)
            console.log(contractorAttendance)
        }
    }, [contractorAttendance])


    useEffect(() => {
        if (insuranceCostItem !== undefined && insuranceCostItem !== InsuranceCostItem) {
            console.log(insuranceCostItem)
            initInsuranceCostItem(insuranceCostItem)
        }
    }, [insuranceCostItem])

    function initInsuranceCostItem(insuranceCostItem) {
        console.log("initInsuranceCostItem")
        var mInsuranceCostItem = new ReqInsuranceCostItem({})
        mInsuranceCostItem.fromJson(insuranceCostItem)
        mInsuranceCostItem.setInsuranceRecruitmentList(insuranceCostItem.InsuranceRecruitmentList)
        mInsuranceCostItem.setInsuranceAmount()
        // console.log(mInsuranceCostItem)

        setInsuranceCostItem(mInsuranceCostItem)
        setInsuranceRecruitmentList(mInsuranceCostItem.InsuranceRecruitmentList)
        setInsuranceAmount(mInsuranceCostItem.InsuranceAmount)
        setInsuranceCostRate(mInsuranceCostItem.InsuranceCostRate)

        var mReqInsuranceCostRate = mInsuranceCostItem.InsuranceCostRate
        console.log(mReqInsuranceCostRate)
        setAccidentRate(mReqInsuranceCostRate.AccidentRate)
        setEmploymentRate(mReqInsuranceCostRate.EmploymentRate)
        setOccupationalAccidentRate(mReqInsuranceCostRate.OccupationalAccidentRate)
        setWageArrearsPaymentFundRate(mReqInsuranceCostRate.WageArrearsPaymentFundRate)
        setLaborPensionRate(mReqInsuranceCostRate.LaborPensionRate)
        setHealthRate(mReqInsuranceCostRate.HealthRate)
        setFamilyAVG(mReqInsuranceCostRate.FamilyAVG)
        setCustomerSupplementaryPremium(mReqInsuranceCostRate.CustomerSupplementaryPremium)
        setFoundRate(mReqInsuranceCostRate.FoundRate)

        setCompanyAmount(mInsuranceCostItem.InsuranceAmount.Company.Amount)
        setCompanyLaborInsurance(mInsuranceCostItem.InsuranceAmount.Company.LaborInsurance)
        setCompanyLaborPension(mInsuranceCostItem.InsuranceAmount.Company.LaborPension)
        setCompanyHealthInsurance(mInsuranceCostItem.InsuranceAmount.Company.HealthInsurance)
        setCompanyGroupInsurance(mInsuranceCostItem.InsuranceAmount.Company.GroupInsurance)
        setCompanyPersonPremium(mInsuranceCostItem.InsuranceAmount.Company.PersonPremium)
        setCompanyAddInsuranceBurdenType(mInsuranceCostItem.InsuranceAmount.Company.AddInsuranceBurdenType)
        setCompanyServiceFee(mInsuranceCostItem.InsuranceAmount.Company.ServiceFee)

        setCustomerAmount(mInsuranceCostItem.InsuranceAmount.Customer.Amount)
        setCustomerLaborInsurance(mInsuranceCostItem.InsuranceAmount.Customer.LaborInsurance)
        setCustomerLaborPension(mInsuranceCostItem.InsuranceAmount.Customer.LaborPension)
        setCustomerHealthInsurance(mInsuranceCostItem.InsuranceAmount.Customer.HealthInsurance)
        setCustomerGroupInsurance(mInsuranceCostItem.InsuranceAmount.Customer.GroupInsurance)
        setCustomerPersonPremium(mInsuranceCostItem.InsuranceAmount.Customer.PersonPremium)
        setCustomerAddInsuranceBurdenType(mInsuranceCostItem.InsuranceAmount.Customer.AddInsuranceBurdenType)
        setCustomerServiceFee(mInsuranceCostItem.InsuranceAmount.Customer.ServiceFee)

        setPersonAmount(mInsuranceCostItem.InsuranceAmount.Person.Amount)
        setPersonLaborInsurance(mInsuranceCostItem.InsuranceAmount.Person.LaborInsurance)
        setPersonLaborPension(mInsuranceCostItem.InsuranceAmount.Person.LaborPension)
        setPersonHealthInsurance(mInsuranceCostItem.InsuranceAmount.Person.HealthInsurance)
        setPersonGroupInsurance(mInsuranceCostItem.InsuranceAmount.Person.GroupInsurance)
        setPersonPersonPremium(mInsuranceCostItem.InsuranceAmount.Person.PersonPremium)
        setPersonAddInsuranceBurdenType(mInsuranceCostItem.InsuranceAmount.Person.AddInsuranceBurdenType)
        setPersonServiceFee(mInsuranceCostItem.InsuranceAmount.Person.ServiceFee)

        setFoundAmount(mInsuranceCostItem.InsuranceAmount.Found.Amount)
        setFoundServiceFee(mInsuranceCostItem.InsuranceAmount.Found.ServiceFee)
        if (init) {
            setInit(false)
        }
    }

    useEffect(() => {
        if (init)
            return
        console.log("改變")
        var mReqInsuranceCostRate = new ReqInsuranceCostRate({
            AccidentRate, EmploymentRate, OccupationalAccidentRate, WageArrearsPaymentFundRate, LaborPensionRate, HealthRate, FamilyAVG, CustomerSupplementaryPremium, FoundRate
        })

        var mInsuranceCostItem = new ReqInsuranceCostItem({})
        mInsuranceCostItem.fromJson(insuranceCostItem)
        mInsuranceCostItem.setInsuranceCostRate(mReqInsuranceCostRate)

        var list = []
        mInsuranceCostItem.InsuranceRecruitmentList.forEach((recruitment, index) => {
            var mReqInsuranceRecruitmentItem = new ReqInsuranceRecruitmentItem({})
            mReqInsuranceRecruitmentItem.fromJson(recruitment)
            mReqInsuranceRecruitmentItem.setAmount(mReqInsuranceCostRate)
            list.push(mReqInsuranceRecruitmentItem)
        })
        mInsuranceCostItem.setInsuranceRecruitmentList(list)
        mInsuranceCostItem.setInsuranceAmount()
        // console.log(mInsuranceCostItem)
        initInsuranceCostItem(JSON.parse(JSON.stringify(mInsuranceCostItem)))

    }, [AccidentRate, EmploymentRate, OccupationalAccidentRate, WageArrearsPaymentFundRate, LaborPensionRate, HealthRate, FamilyAVG, CustomerSupplementaryPremium, FoundRate])

    function setOpenDialog(title, content, action) {
        setDialogTitle(title)
        setDialogContent(content)
        setDialogAction(action)
        setOpen(true)
    }

    function save() {
        var contractorAttendance = getReqContractorAttendance()
        console.log(contractorAttendance)
        toSave(contractorAttendance)
    }

    //送出計算結果
    function send() {
        var contractorAttendance = getReqContractorAttendance()
        if (type === "Monthly") {
            var mContractorAttendanceInfo_SalaryMonthly = new ContractorAttendanceInfo_SalaryMonthly({})
            mContractorAttendanceInfo_SalaryMonthly.fromJson(contractorAttendance.info.salaryMonthly)
            mContractorAttendanceInfo_SalaryMonthly.setInsuranceCosts({
                Amount: InsuranceCostItem.InsuranceAmount.Company.Amount,
                // Notice,
                // Action,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            mContractorAttendanceInfo_SalaryMonthly.setFound({
                Amount: InsuranceCostItem.InsuranceAmount.Found.Amount,
                // Notice,
                // Action,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            mContractorAttendanceInfo_SalaryMonthly.setServiceFee({
                Amount: InsuranceCostItem.InsuranceAmount.Company.ServiceFee,
                // Notice,
                // Action,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            contractorAttendance.info.salaryMonthly = mContractorAttendanceInfo_SalaryMonthly
        } else if (type === "Hourly") {
            var mContractorAttendanceInfo_SalaryHourly = new ContractorAttendanceInfo_SalaryHourly({})
            mContractorAttendanceInfo_SalaryHourly.fromJson(contractorAttendance.info.salaryHourly)
            mContractorAttendanceInfo_SalaryHourly.setInsuranceCosts({
                Amount: InsuranceCostItem.InsuranceAmount.Company.Amount,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            mContractorAttendanceInfo_SalaryHourly.setFound({
                Amount: InsuranceCostItem.InsuranceAmount.Found.Amount,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            mContractorAttendanceInfo_SalaryHourly.setServiceFee({
                Amount: InsuranceCostItem.InsuranceAmount.Company.ServiceFee,
                ActionTime: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
            })
            contractorAttendance.info.salaryHourly = mContractorAttendanceInfo_SalaryHourly
        }
        console.log(contractorAttendance)
        toSave(contractorAttendance)
    }

    function getReqContractorAttendance() {
        var contractorAttendance = new ReqContractorAttendance({})
        contractorAttendance.fromJson(mReqContractorAttendance)
        if (type === "Monthly") {
            contractorAttendance.info.salaryMonthly.InsuranceCostItem = InsuranceCostItem
        } else if (type === "Hourly") {
            contractorAttendance.info.salaryHourly.InsuranceCostItem = InsuranceCostItem
        }
        return contractorAttendance
    }

    function toCancel() {
        setOpen(false)
    }



    var title = <>上工總人數<span className="text-success">{InsuranceRecruitmentList.length}</span>人</>
    var content =
        <>
            {/* <Button onClick={e=>setOpen(true)}>scroll=paper</Button> */}
            <DailogHtml isOpen={open} sOpen={setOpen} title={dialogTitle} content={dialogContent} action={dialogAction} />

            <div className="row">
                <div className="col-sm-12">
                    <SingleInput title={"普通事故費率%"} val={AccidentRate} action={setAccidentRate} type={"number"} step={0.1} size={2} />
                    <SingleInput title={"就業保險費率%"} val={EmploymentRate} action={setEmploymentRate} type={"number"} step={0.1} size={2} />
                    <SingleInput title={"職業災害保險費率%"} val={OccupationalAccidentRate} action={setOccupationalAccidentRate} type={"number"} step={0.01} size={2} />
                    <SingleInput title={"工資墊償基金提繳費率%"} val={WageArrearsPaymentFundRate} action={setWageArrearsPaymentFundRate} type={"number"} step={0.001} size={2} />
                    <SingleInput title={"勞工退休基金費率%"} val={LaborPensionRate} action={setLaborPensionRate} type={"number"} step={0.1} size={2} />
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-sm-12">
                    <SingleInput title={"健保費率%"} val={HealthRate} action={setHealthRate} type={"number"} step={0.01} size={2} />
                    <SingleInput title={"本人及平均眷口數"} val={FamilyAVG} action={setFamilyAVG} type={"number"} step={0.01} size={2} />
                    <SingleInput title={"廠商負擔補充保費合計金額"} val={CustomerSupplementaryPremium} action={setCustomerSupplementaryPremium} type={"number"} size={2} />
                    <SingleInput title={"保險基金費率%"} val={FoundRate} action={setFoundRate} type={"number"} step={0.1} size={2} />
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">姓名</th>
                                    <th className="text-center sorting col-sm-1">職務</th>
                                    <th className="text-center sorting col-sm-1">出勤</th>
                                    <th className="text-center sorting col-sm-1">級距</th>
                                    <th className="text-center sorting col-sm-1">勞保</th>
                                    <th className="text-center sorting col-sm-1">勞退</th>
                                    <th className="text-center sorting col-sm-1">級距</th>
                                    <th className="text-center sorting col-sm-1">健保</th>
                                    <th className="text-center sorting col-sm-1">團保</th>
                                    <th className="text-center sorting col-sm-1">個人負擔</th>
                                    <th className="text-center sorting col-sm-1">補充保費</th>
                                    <th className="text-center sorting col-sm-1">服務費</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* {console.log(InsuranceRecruitmentList)} */}
                                {
                                    InsuranceRecruitmentList.map((recruitment) => (
                                        <RecruitmentBox key={recruitment.caseContractor}
                                            recruitment={recruitment}
                                            // insurance={InsuranceListItems[recruitment.customerPositionId]}
                                            setDialog={setOpenDialog}
                                            setOpen={setOpen}
                                            // action={setRecruitment}
                                            getContractor={getContractor}
                                        />
                                    ))
                                }
                                <tr role="row">
                                    <td className="text-center">公司負擔合計</td>
                                    <td className="text-center">{getDangerText(Number(CompanyAmount).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getDangerText(Number(CompanyLaborInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-right">{getDangerText(Number(CompanyLaborPension).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getDangerText(Number(CompanyHealthInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-right">{getDangerText(Number(CompanyGroupInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getDangerText(Number(CompanyAddInsuranceBurdenType).toLocaleString('en-US'))}</td>
                                    <td className="text-right">{getSuccessText(Number(CompanyServiceFee).toLocaleString('en-US'))}</td>
                                </tr>
                                <tr role="row">
                                    <td className="text-center">廠商負擔合計</td>
                                    <td className="text-center">{getSuccessText(Number(CustomerAmount).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getSuccessText(Number(CustomerLaborInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-right">{getSuccessText(Number(CustomerLaborPension).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getSuccessText(Number(CustomerHealthInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-right">{getSuccessText(Number(CustomerGroupInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getSuccessText(Number(CustomerAddInsuranceBurdenType).toLocaleString('en-US'))}</td>
                                    <td className="text-right"></td>
                                </tr>
                                <tr role="row">
                                    <td className="text-center">個人負擔合計</td>
                                    <td className="text-center">{getInfoText(Number(PersonAmount).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getInfoText(Number(PersonLaborInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-right"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getInfoText(Number(PersonHealthInsurance).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{getInfoText(Number(PersonPersonPremium).toLocaleString('en-US'))}</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                                <tr role="row">
                                    <td className="text-center">保險基金合計</td>
                                    <td className="text-center">{Number(FoundAmount).toLocaleString('en-US')}</td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-right">{Number(FoundServiceFee).toLocaleString('en-US')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="hr-line-dashed"></div>


                    <div className="row">
                        <div className="col-md-12">

                            <div className="col-md-10">
                                <p></p>
                                <p>保費顏色代表：{getDangerText("公司負擔")}、{getSuccessText("廠商負擔")}、{getInfoText("個人負擔")}</p>
                                <p>普通事故保險及就業保險：個人負擔20%、單位負擔70%、政府負擔10%</p>
                                <p>健康保險：個人負擔30%、單位負擔60%、政府負擔10%</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    var footer =
        <div className="row">
            <div className="col-sm-12">
                <div className="col-md-3">

                    {/* <SearchButton name={"下載範例CSV檔"} icon={""} /> */}
                </div>

                <div className="col-md-3">
                    {/* <SearchButton name={"上傳CSV檔"} icon={""} /> */}
                </div>
                <SubmitButton name={"送出計算結果"} action={send} isRight={true} />
                <SubmitButton name={"儲存計算資料"} action={save} isRight={true} />
            </div>
        </div>
    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={false} footer={footer} />
        </>
    )
}


function RecruitmentBox({ recruitment, insurance, setDialog, setOpen }) {
    const [Recruitment, setRecruitment] = useState("")

    const [caseContractor, setCaseContractor] = useState("")

    const [InsuranceBurdenType, setInsuranceBurdenType] = useState(1)
    const [GroupInsuranceBurdenType, setGroupInsuranceBurdenType] = useState(1)
    const [Name, setName] = useState("")
    const [Job, setJob] = useState("")
    const [AttendanceDay, setAttendanceDay] = useState(0)
    const [LaborInsuranceLevelAmount, setLaborInsuranceLevelAmount] = useState("")
    const [UnitLaborInsurance, setUnitLaborInsurance] = useState(0)
    const [PersonLaborInsurance, setPersonLaborInsurance] = useState(0)
    const [LaborPension, setLaborPension] = useState(0)
    const [HealthInsuranceLevelAmount, setHealthInsuranceLevelAmount] = useState(0)
    const [UnitHealthInsurance, setUnitHealthInsurance] = useState([])
    const [PersonHealthInsurance, setPersonHealthInsurance] = useState(0)
    const [GroupInsurance, setGroupInsurance] = useState(0)
    const [PersonPremiumAmount, setPersonPremiumAmount] = useState(0)
    const [AddInsuranceBurdenType, setAddInsuranceBurdenType] = useState(0)
    const [ServiceFee, setServiceFee] = useState(0)
    const [init, setInit] = useState(true)

    useEffect(() => {
        if (recruitment !== undefined && recruitment !== Recruitment) {
            // console.log(recruitment)
            setRecruitment(recruitment)
            setCaseContractor(recruitment.caseContractor)
            setInsuranceBurdenType(recruitment.InsuranceBurdenType)
            setGroupInsuranceBurdenType(recruitment.GroupInsuranceBurdenType)
            setName(recruitment.Name)
            setJob(recruitment.Job)
            setAttendanceDay(recruitment.AttendanceDay)
            setLaborInsuranceLevelAmount(recruitment.LaborInsuranceLevelAmount)
            setUnitLaborInsurance(recruitment.UnitLaborInsurance)
            setPersonLaborInsurance(recruitment.PersonLaborInsurance)
            setLaborPension(recruitment.LaborPension)
            setHealthInsuranceLevelAmount(recruitment.HealthInsuranceLevelAmount)
            setUnitHealthInsurance(recruitment.UnitHealthInsurance)
            setPersonHealthInsurance(recruitment.PersonHealthInsurance)
            setGroupInsurance(recruitment.GroupInsurance)
            setPersonPremiumAmount(recruitment.PersonPremiumAmount)
            setAddInsuranceBurdenType(recruitment.AddInsuranceBurdenType)
            setServiceFee(recruitment.ServiceFee)
        }
    }, [recruitment])

    function DailogCancel() {
        // console.log("DailogCancel")
        setOpen(false)
    }

    function setDailogAttendanceDay() {
        // console.log(Recruitment)
        var title =
            <>
                <span className="text-success">{Name}</span>
                <span className="text-primary">出勤計算</span>
            </>
        var content = <ContractorAttendanceDailogAttendanceDay obj={recruitment} />
        var action = <CancelButton name={"返回"} action={DailogCancel} />
        setDialog(title, content, action)
    }


    return (
        <>
            <tr role="row">
                <td className="text-center">{Name}&nbsp;</td>
                <td className="text-center">{Job}</td>
                <td className="text-center"><a href="#A" onClick={e => setDailogAttendanceDay()}>{AttendanceDay}</a></td>
                <td className="text-center">{Number(LaborInsuranceLevelAmount).toLocaleString('en-US')}</td>
                <td className="text-right">
                    {InsuranceBurdenType === InsuranceBurdenType_Company
                        ? getDangerText(Number(UnitLaborInsurance).toLocaleString('en-US'))
                        : getSuccessText(Number(UnitLaborInsurance).toLocaleString('en-US'))}
                    /
                    {getInfoText(Number(PersonLaborInsurance).toLocaleString('en-US'))}</td>
                <td className="text-right">
                    {InsuranceBurdenType === InsuranceBurdenType_Company
                        ? getDangerText(Number(LaborPension).toLocaleString('en-US'))
                        : getSuccessText(Number(LaborPension).toLocaleString('en-US'))}
                </td>
                <td className="text-right">{Number(HealthInsuranceLevelAmount).toLocaleString('en-US')}</td>
                <td className="text-right">
                    {InsuranceBurdenType === InsuranceBurdenType_Company
                        ? getDangerText(Number(UnitHealthInsurance).toLocaleString('en-US'))
                        : getSuccessText(Number(UnitHealthInsurance).toLocaleString('en-US'))}
                    /
                    {getInfoText(Number(PersonHealthInsurance).toLocaleString('en-US'))}
                </td>
                <td className="text-right">
                    {GroupInsuranceBurdenType === InsuranceBurdenType_Company
                        ? getDangerText(Number(GroupInsurance).toLocaleString('en-US'))
                        : getSuccessText(Number(GroupInsurance).toLocaleString('en-US'))}
                </td>
                <td className="text-right">{getInfoText(Number(PersonPremiumAmount).toLocaleString('en-US'))}</td>
                <td className="text-right">
                    {InsuranceBurdenType === InsuranceBurdenType_Company
                        ? getDangerText(Number(AddInsuranceBurdenType).toLocaleString('en-US'))
                        : getSuccessText("N/A")}
                </td>
                <td className="text-right">{getSuccessText(Number(ServiceFee).toLocaleString('en-US'))}</td>
            </tr>
        </>
    )
}
